module.exports = __webpack_public_path__ + "img/lv15.870f7069.png";